import { AnimatePresence, motion } from 'motion/react'
import { LoaderHtml, LoadingBarHtml } from './LoaderHtml'
import { useContext, useEffect, useState } from 'react'
import zIndexes from '../theme/zIndexes'
import RootStore from '../stores/RootStore'

const LoadingSplash = () => {
  const [render, setRender] = useState(true)

  const store = useContext(RootStore)

  useEffect(() => {
    setRender(!store.ready)
  }, [store.ready])

  const translate = 60 / 7

  return <AnimatePresence key={'loading-splash'}>
    {render && <motion.div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        margin: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100dvh',
        backgroundColor: '#f6f6fa',
        width: '100dvw',
        zIndex: zIndexes.loadingIndicator,
        pointerEvents: 'none',
      }}
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5, delay: 0.2 }}
    >
      <motion.div
        initial={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        transition={{ duration: 0.3, delay: 0 }}
      >
        <div
          style={{
            top: 0,
            left: 0,
            margin: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100dvh',
            backgroundColor: '#f6f6fa',
            width: '100dvw',
          }}
        >
          <style>{`
        @keyframes fadeInAndSlide {
          0% { opacity: 0; transform: translateY(${translate}px); }
          15% { opacity: 1; transform: translateY(0); }
          85% { opacity: 1; transform: translateY(0); }
          100% { opacity: 0; transform: translateY(-${translate}px); }
        }

        @keyframes logoFadeInOut {
          0%, 100% { opacity: 0.7 }
          50% { opacity: 1.0 }
        }

        @keyframes loadingBar {
          0% { transform: scaleX(0) }
          10% { transform: scaleX(0.4) }
          20% { transform: scaleX(0.5) }
          30% { transform: scaleX(0.6) }
          50% { transform: scaleX(0.6) }
          70% { transform: scaleX(0.8) }
          100% { transform: scaleX(0.9) }
        }
      `}</style>
          {LoaderHtml}
          {LoadingBarHtml}
        </div>
      </motion.div>
    </motion.div>}
  </AnimatePresence>
}

export default LoadingSplash